module.exports = __webpack_public_path__ + "static/pinkmummyme4-c0aa3b2b111e6e3afc3407b14a3ea754.png";